var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center",attrs:{"id":"wrap-menu"}},[_c('div',{class:{open: _vm.hidden},attrs:{"id":"sub-menu"}},[_c('span'),_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }